export default __webpack_public_path__ + "static/media/Luuri_Neutraali.509cb16a.svg";